import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BuildingOpeningHoursFormService } from './building-opening-hours.form.service';
import { CourseInstanceFormService } from './course-instance.form.service';
import { InvoiceFormService } from './invoice.form.service';

import { RoomBookingFormService } from './room-booking.form.service';
import { ServiceFormService } from './service.form.service';
import { StandaloneServiceBookingFormService } from './standalone-service-booking.form.service';
import { SurveyFormService } from './survey.form.service';

const FORMS = [
  RoomBookingFormService,
  ServiceFormService,
  StandaloneServiceBookingFormService,
  InvoiceFormService,
  BuildingOpeningHoursFormService,
  SurveyFormService,
  CourseInstanceFormService,
];

@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [
    ...FORMS,
  ],
})
export class AppFormsModule {
  static forRoot(): ModuleWithProviders<AppFormsModule> {
    return {
      ngModule: AppFormsModule,
      providers: [
        ...FORMS,
      ],
    } as ModuleWithProviders<AppFormsModule>;
  }
}
